// Replace your current error handler in index.js with this comprehensive version:

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { loader } from '@monaco-editor/react'; 

// Comprehensive ResizeObserver error suppression
const suppressResizeObserverErrors = () => {
  // Method 1: Global error handler
  window.addEventListener('error', (e) => {
    if (
      e.message && 
      (e.message.includes('ResizeObserver loop completed with undelivered notifications') ||
       e.message.includes('ResizeObserver loop limit exceeded'))
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  });

  // Method 2: Override console.error to filter ResizeObserver errors
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const errorMessage = args[0];
    if (
      typeof errorMessage === 'string' && 
      (errorMessage.includes('ResizeObserver loop completed with undelivered notifications') ||
       errorMessage.includes('ResizeObserver loop limit exceeded'))
    ) {
      return; // Suppress these specific errors
    }
    originalConsoleError.apply(console, args);
  };

  // Method 3: Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    if (
      e.reason?.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
      e.reason?.message?.includes('ResizeObserver loop limit exceeded')
    ) {
      e.preventDefault();
      return false;
    }
  });

  // Method 4: Monkey patch ResizeObserver to debounce notifications
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    
    window.ResizeObserver = class extends OriginalResizeObserver {
      constructor(callback) {
        let timeoutId;
        
        const debouncedCallback = (entries, observer) => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            try {
              callback(entries, observer);
            } catch (error) {
              if (!error.message.includes('ResizeObserver loop completed')) {
                throw error;
              }
            }
          }, 16); // One frame delay
        };
        
        super(debouncedCallback);
      }
    };
  }
};

// Initialize error suppression
suppressResizeObserverErrors();

loader.config({
    paths: {
        vs: 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/vs'
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

reportWebVitals();